import type { UseCase } from '@/core/shared'
import type { AccessConfigRepository } from '../domain'

export const getUserAccessConfigByGroup: UseCase<AccessConfigRepository, 'getUserAccessConfigByGroup'> = repository => {
  return async (userId: number, groupUid: string) => {
    return await repository.getUserAccessConfigByGroup(userId, groupUid)
  }
}
